module.exports = __webpack_public_path__ + "media/packs/upsell-5be2afcfa0f9fa5ac5ea8faf6a41c892.svg";